import * as Yup from 'yup';

const Form3 = Yup.object({
    education: Yup.string().required('Education is required'),
    seniority: Yup.string().required('Seniority is required'),
    jobFunction: Yup.string().required('Job function is required'),
    industry: Yup.string().required('Industry is required'),
})

export default Form3;